<template lang="html">
  <section class="screen-onboarding">
    <transition>
      <div class="ink" v-if="showInk" />
    </transition>
    <transition-group class="page-container" name="slide" tag="div">
      <prt-loader :duration="3" key="loader" @completed="loaderComplete" />
      <div class="page" key="page1" v-if="page === 1">
        <h1>Welcome to Prt Mny!</h1>
        <span>Your safe harbour to keep track of what happens in your wallet.</span>
        <prt-button @click.native="page++">Get Started</prt-button>
      </div>
      <div class="page" key="page2" v-if="page === 2">
        <h1>Keep track of your spending habits.</h1>
        <span>Simply record any money entering or leaving your wallet and get a clear overview of all your transactions.</span>
        <prt-button @click.native="page++">Seems useful</prt-button>
      </div>
      <div class="page" key="page3" v-if="page === 3">
        <h1>It’s secure.</h1>
        <span>Your data is yours alone and never leaves your device.<br>Should you ever need to switch devices, you can simply export your data from the settings.</span>
        <prt-button @click.native="page++">Nice</prt-button>
      </div>
      <div class="page" key="page4" v-if="page === 4">
        <h1>One last thing.</h1>
        <span>Please enter the exact amount of money that’s currently in your wallet to get started:</span>
        <prt-input :error="!iwbValid" type="number" v-model.number="initialWalletBalance" @keyup.enter.native="completeOnboarding"/>
        <prt-button :disabled="!iwbValid" @click.native="completeOnboarding">Finish Onboarding</prt-button>
        <a href="#" @click="importData">Import data from backup</a>
      </div>
    </transition-group>
    <input accept=".json" ref="dataInput" style="display: none" type="file" @change="readData">
  </section>
</template>

<script>
import PrtButton from './ui/PrtButton.vue';
import PrtInput from './ui/PrtInput.vue';
import PrtLoader from './ui/PrtLoader.vue';

export default {
  components: {
    PrtButton,
    PrtInput,
    PrtLoader,
  },
  computed: {
    iwbValid() {
      return this.initialWalletBalance >= 0 && typeof this.initialWalletBalance === 'number' && !Number.isNaN(this.initialWalletBalance);
    },
  },
  data() {
    return {
      initialWalletBalance: 0,
      page: 0,
      showInk: false,
    };
  },
  methods: {
    completeOnboarding() {
      if (this.iwbValid) {
        this.$store.dispatch('updateCurrentWalletBalance', this.initialWalletBalance)
          .then(this.$store.dispatch('setOnboardingComplete'))
          .then(this.$router.push('/'))
          .catch(err => this.$store.commit('addToast', { content: `Could not finish onboarding: ${err.message}`, color: 'negative', timeout: 5000 }));
      }
    },
    importData() {
      this.$refs.dataInput.click();
    },
    loaderComplete() {
      this.showInk = true;
      this.page = 1;
    },
    readData(e) {
      this.$store.commit('setLoadingModal', 'Importing Data…');
      const fileReader = new FileReader();
      fileReader.readAsText(e.target.files[0]);
      fileReader.addEventListener('loadend', (evt) => {
        try {
          const data = JSON.parse(evt.target.result);
          this.$store.dispatch('importData', data)
            .then(() => {
              this.$store.dispatch('initializeState');
              this.$store.commit('setLoadingModal', '');
              this.$router.push('/');
            })
            .catch((err) => {
              this.$store.commit('setLoadingModal', '');
              this.$store.commit('addToast', { color: 'negative', content: `Could not import data: ${err.message}`, timeout: 5000 });
            });
        } catch (err) {
          this.$store.commit('setLoadingModal', '');
          this.$store.commit('addToast', { color: 'negative', content: 'Could not import data: File is invalid JSON', timeout: 5000 });
        }
      });
    },
  },
  name: 'Onboarding',
};
</script>

<style lang="stylus">
  @require '../styles/colors'

  .screen-onboarding
    height: 100vh
    overflow: hidden
    display: flex
    align-items: center
    justify-content: center
    flex-direction: column

    .ink
      position: absolute
      top: calc(50% - 100vmax)
      left: calc(50% - 100vmax)
      width: 200vmax
      height: @width
      border-radius: 50%
      background-color: positive
      transition: transform 500ms ease

      &.v-enter
        transform: scale(0)

    .page-container
      display: flex
      align-items: center
      justify-content: center
      flex-direction: column
      position: relative
      z-index: 2

      *
        flex-shrink: 0

      .slide-move
        transition: transform 200ms ease

      .prt-loader
        margin-bottom: 24px

      .page
        text-align: center
        color: white
        padding: 0 16px

        h1
          margin: 0
          margin-bottom: 8px

        span
          max-width: 504px
          display: block
          margin-bottom: 24px

        .prt-button
          color: black-87
          display: block
          margin: auto

          &:not(:last-child)
            margin-bottom: 24px

        .prt-input input
          text-align: center

        a
          text-decoration: none
          color: inherit

        &.slide-enter-active,
        &.slide-leave-active
          transition: transform 200ms ease, opacity 200ms ease

        &.slide-enter-active
          transition-delay: 200ms

        &.slide-leave-active
          height: 0
          min-height: 0

        &.slide-enter,
        &.slide-leave-to
          opacity: 0

        &.slide-enter
          transform: translateX(20vw)

        &.slide-leave-to
          transform: translateX(-20vw)

</style>
